import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/profession';

const fetchProfessions = createAction('fetchProfessions');

function fetchProfessionsSuccess(state, action) {
  const { professions } = action.payload;
  state.professions = professions;
  state.successFetching = true;
  state.errorFetching = false;
}

function fetchProfessionsError(state) {
  state.professions = [];
  state.successFetching = false;
  state.errorFetching = true;
}

const professionsReducer = createSlice({
  name: 'professions',
  initialState,
  reducers: {
    fetchProfessionsSuccess,
    fetchProfessionsError,
  },
});

export const professionActions = {
  ...professionsReducer.actions,
  fetchProfessions,
};

export default professionsReducer.reducer;
